import { useQuery } from "@tanstack/react-query";
import { Link } from "wouter";
import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export function InboxBell() {
  const { data } = useQuery<{ count: number }>({
    queryKey: ["/api/inbox/unread-count"],
    queryFn: async () => {
      const res = await fetch('/api/inbox/unread-count', { credentials: 'include' });
      if (!res.ok) return { count: 0 };
      return res.json();
    },
    refetchInterval: 60000,
    staleTime: 30000,
  });

  const count = data?.count || 0;

  return (
    <Link href="/inbox" data-testid="link-inbox-bell">
      <Button
        variant="ghost"
        size="icon"
        className="relative h-10 w-10"
        aria-label={count > 0 ? `${count} unread messages in inbox` : 'Inbox'}
        title={count > 0 ? `${count} unread message${count === 1 ? '' : 's'}` : 'Inbox'}
        data-testid="button-inbox-bell"
      >
        <Mail className="h-5 w-5" />
        {count > 0 && (
          <Badge
            className="absolute -top-1 -right-1 h-5 min-w-5 px-1 flex items-center justify-center text-[10px] rounded-full bg-blue-600 hover:bg-blue-600 text-white border-0"
            data-testid="badge-inbox-unread"
          >
            {count > 99 ? '99+' : count}
          </Badge>
        )}
      </Button>
    </Link>
  );
}
